import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.follow()
  }

  // Follow-ups ("If no – why not?") appear once the answer they wait for is
  // picked; hidden again, their inputs are disabled so nothing is sent and
  // nothing is required of them.
  follow() {
    this.element.querySelectorAll("[data-follows]").forEach((question) => {
      const name = `questionnaire_response[answers][${question.dataset.follows}]`
      const picked = [...this.element.querySelectorAll(`[name="${name}"]`)]
        .filter((input) => input.type === "radio" ? input.checked : true)
        .map((input) => input.value)
      const shown = picked.includes(question.dataset.followsAnswer)

      question.hidden = !shown
      question.querySelectorAll("input, select, textarea").forEach((input) => { input.disabled = !shown })
    })
  }

  // HTML5 `required` covers radio/select/multi-select/text/country/date fields.
  // Checkbox groups need a custom check: at least one box in a required group must be ticked.
  validate(event) {
    let firstInvalid = null

    this.element.querySelectorAll("[data-required-checkbox-group]").forEach((group) => {
      if (group.closest("[hidden]")) return

      const checked = group.querySelectorAll("input[type=checkbox]:checked").length
      const message = group.querySelector("[data-required-message]")
      if (checked === 0) {
        if (message) message.classList.remove("hidden")
        if (!firstInvalid) firstInvalid = group
      } else if (message) {
        message.classList.add("hidden")
      }
    })

    if (firstInvalid) {
      event.preventDefault()
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
}
